import React from "react";
import { DropDown } from "../DropDown";
import { DropDownItem } from "../DropDown/DropDown";
import Copy from "../Copy";
import Cut from "../Cut";
import Paste from "../Paste";
import { LexicalProps } from "../../LexicalEditor.types";
import SelectAll from "../SelectAll";
import Undo from "../History/Undo";
import Redo from "../History/Redo";

interface EditProps extends LexicalProps {
  canUndo: boolean;
  canRedo: boolean;
  readOnly?:boolean
}

const Edit = ({ editor, disabled, canUndo, canRedo, readOnly }: EditProps) => {
  return (
    <DropDown
      buttonClassName="lexical-toolbarItem"
      buttonLabel="Edit"
      dropdownIcon={false}
      dropdownItemClass="lexical-dropdown2 lexical-dropDown"
      disabled={readOnly}
    >
      <DropDownItem className="lexical-dropdownItem2">
        <Undo editor={editor} isDropdown={true} canUndo={canUndo} />
      </DropDownItem>
      <DropDownItem className="lexical-dropdownItem2">
        <Redo editor={editor} isDropdown={true} canRedo={canRedo} />
      </DropDownItem>
      <div className="lexical-dividerHorizontal" />
      <DropDownItem className="lexical-dropdownItem2">
        <Cut editor={editor} isDropdown={true} />
      </DropDownItem>
      <DropDownItem className="lexical-dropdownItem2">
        <Copy editor={editor} isDropdown={true} />
      </DropDownItem>
      <DropDownItem className="lexical-dropdownItem2">
        <Paste editor={editor} isDropdown={true} />
      </DropDownItem>
      <div className="lexical-dividerHorizontal" />
      <DropDownItem className="lexical-dropdownItem2">
        <SelectAll editor={editor} isDropdown={true} />
      </DropDownItem>
    </DropDown>
  );
};

export default Edit;
